var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMessage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15 13.75V13.7625",
    stroke: "#0069AA",
    strokeWidth: 1.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10 13.75V13.7625",
    stroke: "#0069AA",
    strokeWidth: 1.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20 13.75V13.7625",
    stroke: "#0069AA",
    strokeWidth: 1.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M22.5 5C23.4946 5 24.4484 5.39509 25.1517 6.09835C25.8549 6.80161 26.25 7.75544 26.25 8.75V18.75C26.25 19.7446 25.8549 20.6984 25.1517 21.4017C24.4484 22.1049 23.4946 22.5 22.5 22.5H16.25L10 26.25V22.5H7.5C6.50544 22.5 5.55161 22.1049 4.84835 21.4017C4.14509 20.6984 3.75 19.7446 3.75 18.75V8.75C3.75 7.75544 4.14509 6.80161 4.84835 6.09835C5.55161 5.39509 6.50544 5 7.5 5H22.5Z",
    stroke: "#0069AA",
    strokeWidth: 1.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMessage);
export default __webpack_public_path__ + "static/media/message.257de896fd3fd16cbca0883def2660a8.svg";
export { ForwardRef as ReactComponent };